import map from "ramda/es/map";
import o from "ramda/es/o";
import pick from "ramda/es/pick";
import { map as rxMap, share, withLatestFrom } from 'rxjs/operators';
import { createFieldRecord } from '../../../utils/data';
import { actionNames } from '../../transfer/control';
import { updateValidationResultMultiple, validationRunner } from '../../transfer/transmission';
import { filterByActionType, groupByFieldRecord } from '../../utils';
export default (({ control$, formFieldState$ })=>{
    return control$.pipe(filterByActionType(actionNames.INSERT_GLOBAL_ERRORS), withLatestFrom(formFieldState$), rxMap(([action, formFieldState])=>{
        const expandedData = o(groupByFieldRecord, map((error)=>{
            const fieldRecord = error.fieldRecord ?? createFieldRecord(error.fieldName, error.fieldIndices);
            return {
                fieldRecord,
                ...pick([
                    'arrayPlacementPath',
                    'arrayDeepPath',
                    'section'
                ], formFieldState[fieldRecord] || {}),
                ...error
            };
        }), action.payload);
        return updateValidationResultMultiple(expandedData, validationRunner.ALL);
    }), share());
});
